// Settings Context - src/context/Settings
import React from 'react';

const LayautContext = React.createContext();

export const Layautconsumer = LayautContext.Consumer;

export default LayautContext;
